import React from "react";
import CG from "./images/CG.png";
import "./App.css";
import Search from "./Search";

export default function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={CG} alt="logo" className="CG img-fluid" />
        <h1>Dictionary App</h1>
      </header>
      <Search />
      <footer>
        <p id="codID">
          This project was coded by{" "}
          <a href="https://github.com/Tauina" target="_blank" rel="noreferrer">
            Catarina Gouveia
          </a>{" "}
          and is{" "}
          <a
            href="https://github.com/Tauina/react-dictionary"
            target="_blank"
            rel="noreferrer"
          >
            open-sourced on GitHub
          </a>{" "}
          and{" "}
          <a
            href="https://cute-croquembouche-69ddd5.netlify.app"
            target="_blank"
            rel="noreferrer"
          >
            hosted on Netlify
          </a>
        </p>
        <p>
          Access to my{" "}
          <a
            href="https://timely-hotteok-55ae27.netlify.app"
            target="_blank"
            rel="noreferrer"
          >
            Portfolio
          </a>
        </p>
      </footer>
    </div>
  );
}
